import { rem } from "polished";
import styled from "styled-components";

import { BlockBackgroundColorWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import StyledButtonContainer from "@/components/editor/themes/nolan/shared/cta-button";
import { ColorLabels } from "@/components/editor/utils/colors";

export const BackgroundWrapper = withViewportStyle(BlockBackgroundColorWrapper)`
  &::after {
    content: '';
    display: block;
    height: ${rem(64)};
    background: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
    
    ${(props) => props.$viewport.tablet`
      height: ${rem(90)};
    `}

    ${(props) => props.$viewport.mobile`
      height: ${rem(120)};
    `}
  }
`;

export const PaddingWrapper = withViewportStyle("div")`
  padding: ${rem(80)} ${rem(108)} ${rem(70)};

  ${(props) => props.$viewport.tablet`
    padding: ${rem(80)} ${rem(24)} ${rem(70)};
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)} 0;
  `}
`;

export const Wrapper = withViewportStyle("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(128)};

  ${(props) => props.$viewport.tablet`
      grid-template-columns: 1fr;
      grid-gap: ${rem(24)};
      grid-template-areas:
        "heading"
        "description"
        "button"
        "image";
  `}

  ${(props) => props.$viewport.mobile`
    gap: ${rem(16)};
  `}
`;

export const LeftColumn = withViewportStyle("div")`
  display: grid;
  grid-row-gap: ${rem(40)};
  grid-template-rows: min-content min-content;
  grid-template-areas: "heading" "button" "image";
  
  ${(props) => props.$viewport.tablet`
    display: contents;
  `}
`;

export const RightColumn = withViewportStyle("div")`
  display: grid;
  grid-template-areas: "description";

  ${(props) => props.$viewport.tablet`
    display: contents;
  `}
`;

export const HeadingWrapper = styled.div`
  grid-area: heading;
`;

export const DescriptionWrapper = styled.div`
  grid-area: description;
`;

export const ButtonWrapper = withViewportStyle(StyledButtonContainer)`
  grid-area: button;

  ${(props) => props.$viewport.tablet`
      text-align: center;
  `}
`;

export const ImageWrapper = withViewportStyle("div")`
  grid-area: image;
  margin-top: auto;
  margin-bottom: -${rem(134)};

  ${(props) => props.$viewport.tablet`
    margin-top: ${rem(24)};
    margin-bottom: -${rem(160)};
  `}

  ${(props) => props.$viewport.mobile`
    margin-bottom: -${rem(80)};
  `}

  .image-primitive {
    display: block;
  }
`;
